/**
 * PaymentService — создаёт платёж через наш бэкенд (webhook-server).
 * API-ключ UnoPay хранится ТОЛЬКО на сервере, сюда не попадает.
 */

const PAYMENT_SERVER = '/payment'; // nginx проксирует на webhook-server

export interface CreatePaymentResult {
  payment_url: string;
  transaction_id: string;
}

export interface CheckPaymentResult {
  status: 'paid' | 'pending' | 'expired' | 'failed';
  amount: number;
  currency: string;
  transaction_id: string;
}

/** Создаёт платёжную ссылку. amount в рублях = столько же монет. */
export async function createPayment(
  amount: number,
  uid: string,
): Promise<CreatePaymentResult> {
  const res = await fetch(`${PAYMENT_SERVER}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, uid }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).error || `HTTP ${res.status}`);
  }

  return res.json();
}

/** Проверяет статус платежа по transaction_id. */
export async function checkPayment(transactionId: string): Promise<CheckPaymentResult> {
  const res = await fetch(`${PAYMENT_SERVER}/check?transaction_id=${transactionId}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
